module.exports = __webpack_public_path__ + "img/1499555595.d7cd69b2.jpg";